<template>
  <div>
    <!-- Preloader -->
    <!-- <div class="preloader d-flex align-items-center justify-content-center" v-if="loadingPage">
        <div class="cssload-container">
            <div class="cssload-loading"><i></i><i></i><i></i><i></i></div>
        </div>
    </div> -->
    <!--  ##### Breadcumb Area Start ##### -->
    <!-- 'background-image: url('+ require(offerList.mainImage) + ');' -->
    <section
      class="breadcumb-area bg-img d-sm-flex align-items-center justify-content-center d-none"
      :style="`background-image: url(${offerList.MainImage});`"
    >
      <!-- <div class="bradcumbContent">
                <h2>Rooms</h2>
            </div> -->
    </section>
    <!-- ##### Breadcumb Area End ##### -->
    <div id="roomArea"></div>
    <!-- ##### Rooms Area Start ##### -->
    <!-- <section
      class="rooms-area mt-5 section-padding-0-100"
      style="position: relative;"
    > -->
    <section
      class="rooms-area mt-5 pt-5"
      style="position: relative;"
    >
      <div class="container-fluid pa-0">
        <div class="row">
          <div class="col-12 col-md-2 d-none d-sm-flex">
            <div class="categories sticky-top align-center  my-auto" style="">
              <div class="nav flex-column nav-pills mb-5" id="roomTabs">
                <!-- <a class="nav-link" v-for="(item, index) in offerList.tiles" @click="changeRoute('tile' + index)" data-toggle="pill" :href="item.TileImageTitle ? '#tile' + index : '#'">{{item.TileImageTitle}}</a> -->
                <!-- <a class="nav-link " @click="changeRoute('Deluxe Room')" data-toggle="pill" href="#Excursions" >Deluxe Room</a> -->
                <!-- <a class="nav-link " @click="changeRoute('Superior Room')" data-toggle="pill" href="#SuperiorRoom" >Superior Room</a> -->
                <!-- <a class="nav-link " @click="changeRoute('Garden Room')" data-toggle="pill" href="#GardenRoom" >Garden Room</a> -->
                <!-- <a class="nav-link " id="v-pills-settings-tab" data-toggle="pill" href="#v-pills-settings" >Classic Room</a> -->
                <span v-for="(item, index) in offerList.tiles" :key="index">
                  <a
                    class="nav-link"
                    v-if="item.TileType !== 'link'"
                    @click="changeRoute('tile' + index)"
                    data-toggle="pill"
                    :href="item.TileImageTitle ? '#tile' + index : '#'"
                    >{{ item.TileImageTitle }}</a
                  >
                  <a
                    class="nav-link"
                    v-else
                    @click="openPdfModal(item.TileLink, 'tiles')"
                    >{{ item.TileImageTitle }}</a
                  >
                </span>
              </div>
            </div>
          </div>
          <!-- <div class="d-block d-sm-none">
              <div class="tab-content d-block d-sm-none">
                <div
                  class="tab-pane fade"
                  v-for="(item, index) in offerList.tiles"
                  :id="'tile-modile' + index"
                  :key="index"
                >
                  <local-swiper ref="awesomeSwiperB" :options="swiperOptionB" style="height: 35vh">
                      <local-slide
                        v-for="(image, index) in item.TileSlidesCSV"
                        :key="index"
                        v-if="image"
                      >
                        <div
                          :style="{
                            'background-image':
                              'url(\'https://www.malahini.mv:9443/web/api/picture/' +
                              image +
                              '\')',
                              height: '100%',
                              width: '100%',
                              'background-size': 'contain',
                              'background-repeat': 'no-repeat'
                          }"
                        ></div>
                      </local-slide>
                      <div class="swiper-pagination d-none d-block-md" slot="pagination"></div>
                    </local-swiper>
                    <div class="container pt-5">
                      <p class="h3">
                        {{ item.TileImageTitle }}
                        <span class="float-right"
                          ><a
                            href=""
                            data-toggle="modal"
                            data-target="#exampleModal"
                            @click="openModal(item)"
                            ><img src="icon/photo.svg" alt="" width="30px"/></a
                        ></span>
                      </p>
                      <p>
                        <span v-for="(file, i) in item.Files" :key="i"
                          >|
                          <button
                            type="button"
                            class="btn btn-link link"
                            style="color: #5ea8ae !important; padding: 0"
                            @click="openPdfModal(file.FileName, 'detailFiles')"
                          >
                            {{ file.FileTitle }}
                          </button>
                          <span v-if="i === item.Files.length - 1">|</span>
                        </span>
                      </p>
                      <div class="" v-html="item.TileDetails"></div>
                      <div class="text-center" v-if="page == 'specialoffers'">
                        <a
                          class="btn palatin-btn"
                          style="background-color: #5da9ae; color: white; font-weight: bold;"
                          href="https://reservations.travelclick.com/108582?themeid=19315#/guestsandrooms"
                          target="_blank"
                          v-if="item.TileImageTitle === 'Private Offers'"
                          >Book Now</a
                        >
                        <a
                          class="btn palatin-btn"
                          style="background-color: #5da9ae; color: white; font-weight: bold;"
                          v-else
                          data-toggle="modal"
                          data-target="#bookingDialog"
                          @click="
                            (selectedPackage = item.TileImageTitle),
                              setLimits(item)
                          "
                          >Book This Package</a
                        >
                      </div>
                      <div class="text-center" v-if="page == 'rooms'">
                        <a
                          href="https://reservations.travelclick.com/108582?themeid=19315#/guestsandrooms"
                          target="_blank"
                          class="btn palatin-btn"
                          style="background-color: #5da9ae; color: white; font-weight: bold;"
                          >Book This Room</a
                        >
                      </div>
                    </div>
                </div>
              </div>
            </div> -->
          <div class="col-md-10 pr-0 pl-0">
            <div class="tab-content h-100 d-md-block">
              <div
                class="tab-pane  fade h-100"
                v-for="(item, index) in offerList.tiles"
                :id="'tile' + index"
                :key="index"
              >
              <div class="d-block d-sm-none">
                <local-swiper ref="awesomeSwiperB" :options="swiperOptionB" style="height: 35vh">
                      <local-slide
                        v-for="(image, index) in item.TileSlidesCSV"
                        :key="index"
                        v-if="image"
                      >
                        <div
                          :style="{
                            'background-image':
                              'url(\'https://www.malahini.mv:9443/web/api/picture/' +
                              image +
                              '\')',
                              height: '100%',
                              width: '100%',
                              'background-size': 'contain',
                              'background-repeat': 'no-repeat'
                          }"
                        ></div>
                      </local-slide>
                      <div class="swiper-pagination d-none d-block-md" slot="pagination"></div>
                    </local-swiper>
                    <div class="container pt-5">
                      <p class="h3">
                        {{ item.TileImageTitle }}
                        <span class="float-right"
                          ><a
                            href=""
                            data-toggle="modal"
                            data-target="#exampleModal"
                            @click="openModal(item)"
                            ><img src="icon/photo.svg" alt="" width="30px"/></a
                        ></span>
                      </p>
                      <p>
                        <span v-for="(file, i) in item.Files" :key="i"
                          >|
                          <button
                            type="button"
                            class="btn btn-link link"
                            style="color: #5ea8ae !important; padding: 0"
                            @click="openPdfModal(file.FileName, 'detailFiles')"
                          >
                            {{ file.FileTitle }}
                          </button>
                          <span v-if="i === item.Files.length - 1">|</span>
                        </span>
                      </p>
                      <div class="" v-html="item.TileDetails"></div>
                      <div class="text-center" v-if="page == 'specialoffers'">
                        <a
                          class="btn palatin-btn"
                          style="background-color: #5da9ae; color: white; font-weight: bold;"
                          :href="item.TileLink"
                          target="_blank"
                          >Book Now</a
                        >
                        <!-- remove comment depends on the requirement -->
                        <!-- <a
                          class="btn palatin-btn"
                          style="background-color: #5da9ae; color: white; font-weight: bold;"
                          href="https://reservations.travelclick.com/108582?themeid=19315#/guestsandrooms"
                          target="_blank"
                          v-if="item.TileImageTitle === 'Private Offers' || item.TileImageTitle === 'Eid Offer' ||  item.TileImageTitle === 'Summer offer 2023'"
                          >Book Now</a
                        > -->
                        <!-- <a
                          class="btn palatin-btn"
                          style="background-color: #5da9ae; color: white; font-weight: bold;"
                          v-else
                          data-toggle="modal"
                          data-target="#bookingDialog"
                          @click="
                            (selectedPackage = item.TileImageTitle),
                              setLimits(item)
                          "
                          >Book This Package</a
                        > -->
                      </div>
                      <div class="text-center" v-if="page == 'rooms'">
                        <a
                          href="https://reservations.travelclick.com/108582?themeid=19315#/guestsandrooms"
                          target="_blank"
                          class="btn palatin-btn"
                          style="background-color: #5da9ae; color: white; font-weight: bold;"
                          >Book This Room</a
                        >
                      </div>
                    </div>
              </div>
                <div class="sticky-top d-none d-sm-block" style="z-index: 0; height: 100vh;">
                  <!-- <div id="carouselExampleIndicators" class="carousel slide  carousel-fade w-100 h-100" data-ride="carousel" data-interval="3000" style="position: absolute">
                                            <ol class="carousel-indicators" v-if="item.TileSlidesCSV && item.TileSlidesCSV.length > 1">
                                                <li data-target="#carouselExampleIndicators" data-slide-to="0" class="active"></li>
                                                <li data-target="#carouselExampleIndicators" v-for="(image, index) in item.TileSlidesCSV" v-if="index !== 0" :data-slide-to="index"></li>
                                            </ol>
                                            <div class="carousel-inner h-100" v-if="item.TileSlidesCSV && item.TileSlidesCSV.length > 0">
                                                <div class="carousel-item h-100 active" style="height: 100vh; width: 100%">
                                                    <img class="d-block w-100" :src="`https://test.malahini.mv:8443/web/api/page/picture/${item.TileSlidesCSV[0]}`" alt="First slide" height="100vh">
                                                </div>
                                                <div class="carousel-item h-100" v-for="(image, index) in item.TileSlidesCSV" v-if="index !== 0" style="height: 100vh; width: 100%">
                                                    <img class="d-block w-100" :src="`https://test.malahini.mv:8443/web/api/page/picture/${image}`" alt="" height="100vh" width="100%">
                                                </div>
                                            </div>
                                        </div> -->
                  <local-swiper ref="awesomeSwiperB" :options="swiperOptionB">
                    <local-slide
                      v-for="(image, index) in item.TileSlidesCSV"
                      :key="index"
                      v-if="image"
                    >
                      <div
                        :style="{
                          'background-image':
                            'url(\'https://www.malahini.mv:9443/web/api/picture/' +
                            image +
                            '\')',
                          height: '100%',
                          width: '100%',
                          'background-size': 'cover',
                          'background-position': 'center',
                        }"
                      ></div>
                    </local-slide>
                    <div class="swiper-pagination" slot="pagination"></div>
                  </local-swiper>
                </div>

                <div
                  class="col-md-4 pb-5 h-100  d-none d-sm-block"
                  style="background-color: rgba(100, 100, 100, 0.52); color: white; margin-top: -100vh;"
                >
                  <div class="container pt-5 px-5 room-text mb-5">
                    <p class="h3">
                      {{ item.TileImageTitle }}
                      <!-- <span class="float-right"><a class="white-text" href="" data-toggle="modal" data-target="#exampleModal" @click="openModal(item)"><i class="far fa-2x fa-images" data-toggle="tooltip" data-placement="right" title="View images"></i></a></span> -->
                      <span class="float-right"
                        ><a
                          class="white-text"
                          href=""
                          data-toggle="modal"
                          data-target="#exampleModal"
                          @click="openModal(item)"
                          ><img src="icon/photo.svg" alt="" width="30px"/></a
                      ></span>
                    </p>
                    <p class="white-text">
                      <span v-for="(file, i) in item.Files" :key="i"
                        >|
                        <button
                          type="button"
                          class="btn btn-link link"
                          style="color: #5ea8ae !important; padding: 0"
                          @click="openPdfModal(file.FileName, 'detailFiles')"
                        >
                          {{ file.FileTitle }}
                        </button>
                        <span v-if="i === item.Files.length - 1">|</span>
                      </span>
                    </p>
                    <!-- beach villa -->
                    <!-- <p class="text-justify">Located along the shoreline our Beach Villas are made for contemporary Beach Front Living with an exotic Open Air Bathroom. Each individual standing villa is 40 sq m and have the below to ensure that you enjoy a comfortable stay:</p><br> <div class="row"> <div class="col-4"> <p class="text-center"><object type="image/svg+xml" data="./icon/bed.svg" class="icon">King Sized Bed</object><br>King Sized Bed</p> </div> <div class="col-4"> <p class="text-center"><object type="image/svg+xml" data="./icon/sofa-bed.svg" class="icon">Sofa Bed</object><br>Extra Sofa Bed</p> </div> <div class="col-4"> <p class="text-center"><object type="image/svg+xml" data="./icon/tv.svg" class="icon">LCD Tv</object><br> LCD Television </p> </div> </div> <div class="row"> <div class="col-4"> <p class="text-center"><object type="image/svg+xml" data="./icon/sattelite.svg" class="icon">Satellite TV Channels</object><br>Satellite TV Channels </p> </div> <div class="col-4"> <p class="text-center"><object type="image/svg+xml" data="./icon/air-conditioner.svg" class="icon">Air-conditioning</object><br>Air-conditioning</p> </div> <div class="col-4"> <p class="text-center"><object type="image/svg+xml" data="./icon/tea.svg" class="icon">Tea and Coffee</object><br>Tea and Coffee</p> </div> </div> <div class="row"> <div class="col-4"> <p class="text-center"><object type="image/svg+xml" data="./icon/bottles.svg" class="icon">2 Water Bottles</object><br>2 Water Bottles</p> </div> <div class="col col-4"> <p class="text-center"><object type="image/svg+xml" data="./icon/wifi.svg" class="icon">Free Wifi</object><br>Free Wifi</p> </div> <div class="col col-4"> <p class="text-center"><object type="image/svg+xml" data="./icon/indoor-shower.svg" class="icon">Indoor Standing Shower</object><br>Indoor Standing Shower</p> </div> </div> <div class="row"><div class="col col-4"> <p class="text-center"><object type="image/svg+xml" data="./icon/outdoor-shower.svg" class="icon">Outdoor Standing Shower</object><br>Outdoor Standing Shower</p> </div> <div class="col col-4"> <p class="text-center"><object type="image/svg+xml" data="./icon/bathroom.svg" class="icon">Bath Tub</object><br>Bath Tub</p> </div><div class="col col-4"> <p class="text-center"><object type="image/svg+xml" data="./icon/hot-cold.svg" class="icon">Hot and Cold Water</object><br>Hot and Cold Water</p> </div> <div class="col col-4"> <p class="text-center"><object type="image/svg+xml" data="./icon/phone.svg" class="icon">Telephone</object><br>Telephone</p> </div> <div class="col col-4"> <p class="text-center"><object type="image/svg+xml" data="./icon/minibar.svg" class="icon">Mini Bar</object><br>Mini Bar</p> </div> <div class="col col-4"> <p class="text-center"><object type="image/svg+xml" data="./icon/electrical-adapter.svg" class="icon">Electrical Adaptors</object><br>Electrical Adaptors</p> </div></div> <div class="row">  <div class="col col-4"> <p class="text-center"><object type="image/svg+xml" data="./icon/crib.svg" class="icon">Cot</object><br>Infant Cots upon request</p> </div><div class="col col-4"> <p class="text-center"><object type="image/svg+xml" data="./icon/safe-box.svg" class="icon">Safe</object><br>Room safe included</p> </div><div class="col col-4"> <p class="text-center"><object type="image/svg+xml" data="./icon/spa.svg" class="icon">Bathrobe</object><br>Bathrobe (Free on Request)</p> </div><div class="col col-4"> <p class="text-center"><object type="image/svg+xml" data="./icon/dryer.svg" class="icon">Hair Dryer</object><br>Hair Dryer (Free on Request)</p> </div><div class="col col-4"> <p class="text-center"><object type="image/svg+xml" data="./icon/beach-towel.svg" class="icon">Beach Towels</object><br>Beach Towels</p> </div><div class="col col-4"> <p class="text-center"><object type="image/svg+xml" data="./icon/iron.svg" class="icon">Iron and Ironing Board</object><br>Iron and Ironing Board upon request</p> </div></div> <ol class="room-features mb-5"><li>Ocean Inspired Refreshing Bathroom Amenities </li><li>Daily Breakfast at Maaga</li><li >Free SUP, Canoe, Windsurf & Paddleboat included in your room rate</li></ol> -->

                    <!-- Deluxe room -->
                    <!-- <p class="text-justify">Located along the shore, our Deluxe rooms affords a partial view of the Ocean. Each room is 27sq m and have the below to ensure that you enjoy a comfortable stay:</p> <div class="row"> <div class="col-4"> <p class="text-center"><object type="image/svg+xml" data="./icon/bed.svg" class="icon">King Sized Bed</object><br>King Sized Bed</p> </div> <div class="col-4"> <p class="text-center"><object type="image/svg+xml" data="./icon/sofa-bed.svg" class="icon">Sofa Bed</object><br>Extra Sofa Bed</p> </div> <div class="col-4"> <p class="text-center"><object type="image/svg+xml" data="./icon/tv.svg" class="icon">LCD Tv</object> <br> LCD Television </p> </div> </div> <div class="row"> <div class="col-4"> <p class="text-center"><object type="image/svg+xml" data="./icon/sattelite.svg" class="icon">Satellite TV Channels</object><br>Satellite TV Channels </p> </div> <div class="col-4"> <p class="text-center"><object type="image/svg+xml" data="./icon/air-conditioner.svg" class="icon">Air-conditioning</object><br>Air-conditioning</p> </div> <div class="col-4"> <p class="text-center"><object type="image/svg+xml" data="./icon/tea.svg" class="icon">Tea and Coffee</object><br>Tea and Coffee</p> </div> </div> <div class="row"> <div class="col-4"> <p class="text-center"><object type="image/svg+xml" data="./icon/bottles.svg" class="icon">2 Water Bottles</object><br>2 Water Bottles</p> </div> <div class="col col-4"> <p class="text-center"><object type="image/svg+xml" data="./icon/wifi.svg" class="icon">Free Wifi</object><br>Free Wifi</p> </div> <div class="col col-4"> <p class="text-center"><object type="image/svg+xml" data="./icon/indoor-shower.svg" class="icon">Indoor Standing Shower</object><br>Indoor Standing Shower</p> </div> </div> <div class="row"> <div class="col col-4"> <p class="text-center"><object type="image/svg+xml" data="./icon/hot-cold.svg" class="icon">Hot and Cold Water</object><br>Hot and Cold Water</p> </div> <div class="col col-4"> <p class="text-center"><object type="image/svg+xml" data="./icon/phone.svg" class="icon">Telephone</object><br>Telephone</p> </div> <div class="col col-4"> <p class="text-center"><object type="image/svg+xml" data="./icon/minibar.svg" class="icon">Mini Bar</object><br>Mini Bar</p> </div> </div> <div class="row"> <div class="col col-4"> <p class="text-center"><object type="image/svg+xml" data="./icon/electrical-adapter.svg" class="icon">Electrical Adaptors</object><br>Electrical Adaptors</p> </div> <div class="col col-4"> <p class="text-center"><object type="image/svg+xml" data="./icon/crib.svg" class="icon">Cot</object><br>Infant Cots upon request</p> </div><div class="col col-4"> <p class="text-center"><object type="image/svg+xml" data="./icon/safe-box.svg" class="icon">Safe</object><br>Room safe included</p> </div><div class="col col-4"> <p class="text-center"><object type="image/svg+xml" data="./icon/spa.svg" class="icon">Bathrobe</object><br>Bathrobe (Free on Request)</p> </div><div class="col col-4"> <p class="text-center"><object type="image/svg+xml" data="./icon/dryer.svg" class="icon">Hair Dryer</object><br>Hair Dryer (Free on Request)</p> </div><div class="col col-4"> <p class="text-center"><object type="image/svg+xml" data="./icon/beach-towel.svg" class="icon">Beach Towels</object><br>Beach Towels</p> </div><div class="col col-4"> <p class="text-center"><object type="image/svg+xml" data="./icon/iron.svg" class="icon">Iron and Ironing Board</object><br>Iron and Ironing Board upon request</p> </div></div> <ol class="room-features mb-5"><li>Ocean Inspired Refreshing Bathroom Amenities </li><li>Daily Breakfast at Maaga</li><li >Free SUP, Canoe, Windsurf & Paddleboat included in your room rate</li></ol> -->

                    <!-- Superior room -->
                    <!-- <p class="text-justify">Located above the Deluxe Rooms our Superior Rooms affords sweeping partial views of the Ocean. Each room is 18 sq m and have the below to ensure that you enjoy a comfortable stay:</p> <div class="row"> <div class="col"> <p class="text-center"><object type="image/svg+xml" data="./icon/bed.svg" class="icon">King Sized Bed</object><br>King Sized Bed</p> </div> <div class="col"> <p class="text-center"><object type="image/svg+xml" data="./icon/tv.svg" class="icon">LCD Tv</object> <br> LCD Television </p> </div> <div class="col"> <p class="text-center"><object type="image/svg+xml" data="./icon/sattelite.svg" class="icon">Satellite TV Channels</object><br>Satellite TV Channels </p> </div> </div> <div class="row"> <div class="col col-4"> <p class="text-center"><object type="image/svg+xml" data="./icon/air-conditioner.svg" class="icon">Air-conditioning</object><br>Air-conditioning</p> </div> <div class="col col-4"> <p class="text-center"><object type="image/svg+xml" data="./icon/tea.svg" class="icon">Tea and Coffee</object><br>Tea and Coffee</p> </div> <div class="col col-4"> <p class="text-center"><object type="image/svg+xml" data="./icon/bottles.svg" class="icon">2 Water Bottles</object><br>2 Water Bottles</p> </div> </div> <div class="row"> <div class="col col-4"> <p class="text-center"><object type="image/svg+xml" data="./icon/wifi.svg" class="icon">Free Wifi</object><br>Free Wifi</p> </div> <div class="col col-4"> <p class="text-center"><object type="image/svg+xml" data="./icon/indoor-shower.svg" class="icon">Indoor Standing Shower</object><br>Indoor Standing Shower</p> </div> <div class="col col-4"> <p class="text-center"><object type="image/svg+xml" data="./icon/hot-cold.svg" class="icon">Hot and Cold Water</object><br>Hot and Cold Water</p> </div> </div> <div class="row"> <div class="col col-4"> <p class="text-center"><object type="image/svg+xml" data="./icon/phone.svg" class="icon">Telephone</object><br>Telephone</p> </div> <div class="col col-4"> <p class="text-center"><object type="image/svg+xml" data="./icon/minibar.svg" class="icon">Mini Bar</object><br>Mini Bar</p> </div> <div class="col col-4"> <p class="text-center"><object type="image/svg+xml" data="./icon/electrical-adapter.svg" class="icon">Electrical Adaptors</object><br>Electrical Adaptors</p> </div> <div class="col col-4"> <p class="text-center"><object type="image/svg+xml" data="./icon/safe-box.svg" class="icon">Safe</object><br>Room safe included</p> </div><div class="col col-4"> <p class="text-center"><object type="image/svg+xml" data="./icon/spa.svg" class="icon">Bathrobe</object><br>Bathrobe (Free on Request)</p> </div><div class="col col-4"> <p class="text-center"><object type="image/svg+xml" data="./icon/dryer.svg" class="icon">Hair Dryer</object><br>Hair Dryer (Free on Request)</p> </div><div class="col col-4"> <p class="text-center"><object type="image/svg+xml" data="./icon/beach-towel.svg" class="icon">Beach Towels</object><br>Beach Towels</p> </div><div class="col col-4"> <p class="text-center"><object type="image/svg+xml" data="./icon/iron.svg" class="icon">Iron and Ironing Board</object><br>Iron and Ironing Board upon request</p> </div></div> <ol class="room-features mb-5"><li>Ocean Inspired Refreshing Bathroom Amenities </li><li>Daily Breakfast at Maaga</li><li >Free SUP, Canoe, Windsurf & Paddleboat included in your room rate</li> </ol>                                             -->
                    <!-- Garden room -->
                    <!-- <p class="text-justify">Enjoy looking at exotic Banana trees and ferns from our Garden Rooms. Each room is 22-24 sq m and have the below to ensure that you enjoy a comfortable stay:</p> <div class="row"> <div class="col-4"> <p class="text-center"><object type="image/svg+xml" data="./icon/bed.svg" class="icon">King Sized Bed</object><br>King Sized Bed</p> </div> <div class="col-4"> <p class="text-center"><object type="image/svg+xml" data="./icon/sofa-bed.svg" class="icon">Sofa Bed</object><br>Extra Sofa Bed</p> </div> <div class="col-4"> <p class="text-center"><object type="image/svg+xml" data="./icon/tv.svg" class="icon">LCD Tv</object> <br> LCD Television </p> </div> </div> <div class="row"> <div class="col-4"> <p class="text-center"><object type="image/svg+xml" data="./icon/sattelite.svg" class="icon">Satellite TV Channels</object><br>Satellite TV Channels </p> </div> <div class="col-4"> <p class="text-center"><object type="image/svg+xml" data="./icon/air-conditioner.svg" class="icon">Air-conditioning</object><br>Air-conditioning</p> </div> <div class="col-4"> <p class="text-center"><object type="image/svg+xml" data="./icon/tea.svg" class="icon">Tea and Coffee</object><br>Tea and Coffee</p> </div> </div> <div class="row"> <div class="col-4"> <p class="text-center"><object type="image/svg+xml" data="./icon/bottles.svg" class="icon">2 Water Bottles</object><br>2 Water Bottles</p> </div> <div class="col col-4"> <p class="text-center"><object type="image/svg+xml" data="./icon/wifi.svg" class="icon">Free Wifi</object><br>Free Wifi</p> </div> <div class="col col-4"> <p class="text-center"><object type="image/svg+xml" data="./icon/indoor-shower.svg" class="icon">Indoor Standing Shower</object><br>Indoor Standing Shower</p> </div> </div> <div class="row"> <div class="col col-4"> <p class="text-center"><object type="image/svg+xml" data="./icon/hot-cold.svg" class="icon">Hot and Cold Water</object><br>Hot and Cold Water</p> </div> <div class="col col-4"> <p class="text-center"><object type="image/svg+xml" data="./icon/phone.svg" class="icon">Telephone</object><br>Telephone</p> </div> <div class="col col-4"> <p class="text-center"><object type="image/svg+xml" data="./icon/minibar.svg" class="icon">Mini Bar</object><br>Mini Bar</p> </div> </div> <div class="row"> <div class="col col-4"> <p class="text-center"><object type="image/svg+xml" data="./icon/electrical-adapter.svg" class="icon">Electrical Adaptors</object><br>Electrical Adaptors</p> </div> <div class="col col-4"> <p class="text-center"><object type="image/svg+xml" data="./icon/crib.svg" class="icon">Cot</object><br>Infant Cots upon request</p> </div><div class="col col-4"> <p class="text-center"><object type="image/svg+xml" data="./icon/safe-box.svg" class="icon">Safe</object><br>Room safe included</p> </div><div class="col col-4"> <p class="text-center"><object type="image/svg+xml" data="./icon/spa.svg" class="icon">Bathrobe</object><br>Bathrobe (Free on Request)</p> </div><div class="col col-4"> <p class="text-center"><object type="image/svg+xml" data="./icon/dryer.svg" class="icon">Hair Dryer</object><br>Hair Dryer (Free on Request)</p> </div><div class="col col-4"> <p class="text-center"><object type="image/svg+xml" data="./icon/beach-towel.svg" class="icon">Beach Towels</object><br>Beach Towels</p> </div><div class="col col-4"> <p class="text-center"><object type="image/svg+xml" data="./icon/iron.svg" class="icon">Iron and Ironing Board</object><br>Iron and Ironing Board upon request</p> </div></div> <ol class="room-features mb-5"><li>Ocean Inspired Refreshing Bathroom Amenities </li><li>Daily Breakfast at Maaga</li><li >Free SUP, Canoe, Windsurf & Paddleboat included in your room rate</li></ol> -->
                    <!-- Classic room -->
                    <!-- <p class="text-justify">Each room is 18 sq m and have the below to ensure that you enjoy a comfortable stay:</p> <div class="row"> <div class="col-4"> <p class="text-center"><object type="image/svg+xml" data="./icon/bed.svg" class="icon">King Sized Bed</object><br>King Sized Bed</p> </div> <div class="col col-4"> <p class="text-center"><object type="image/svg+xml" data="./icon/electrical-adapter.svg" class="icon">Electrical Adaptors</object><br>Electrical Adaptors</p> </div> <div class="col-4"> <p class="text-center"><object type="image/svg+xml" data="./icon/tv.svg" class="icon">LCD Tv</object> <br> LCD Television </p> </div> </div> <div class="row"> <div class="col-4"> <p class="text-center"><object type="image/svg+xml" data="./icon/sattelite.svg" class="icon">Satellite TV Channels</object><br>Satellite TV Channels </p> </div> <div class="col-4"> <p class="text-center"><object type="image/svg+xml" data="./icon/air-conditioner.svg" class="icon">Air-conditioning</object><br>Air-conditioning</p> </div> <div class="col-4"> <p class="text-center"><object type="image/svg+xml" data="./icon/tea.svg" class="icon">Tea and Coffee</object><br>Tea and Coffee</p> </div> </div> <div class="row"> <div class="col-4"> <p class="text-center"><object type="image/svg+xml" data="./icon/bottles.svg" class="icon">2 Water Bottles</object><br>2 Water Bottles</p> </div> <div class="col col-4"> <p class="text-center"><object type="image/svg+xml" data="./icon/wifi.svg" class="icon">Free Wifi</object><br>Free Wifi</p> </div> <div class="col col-4"> <p class="text-center"><object type="image/svg+xml" data="./icon/indoor-shower.svg" class="icon">Indoor Standing Shower</object><br>Indoor Standing Shower</p> </div> </div> <div class="row"> <div class="col col-4"> <p class="text-center"><object type="image/svg+xml" data="./icon/hot-cold.svg" class="icon">Hot and Cold Water</object><br>Hot and Cold Water</p> </div> <div class="col col-4"> <p class="text-center"><object type="image/svg+xml" data="./icon/phone.svg" class="icon">Telephone</object><br>Telephone</p> </div> <div class="col col-4"> <p class="text-center"><object type="image/svg+xml" data="./icon/minibar.svg" class="icon">Mini Bar</object><br>Mini Bar</p> </div> </div> <div class="row"><div class="col col-4"> <p class="text-center"><object type="image/svg+xml" data="./icon/safe-box.svg" class="icon">Safe</object><br>Room safe included</p> </div><div class="col col-4"> <p class="text-center"><object type="image/svg+xml" data="./icon/spa.svg" class="icon">Bathrobe</object><br>Bathrobe (Free on Request)</p> </div><div class="col col-4"> <p class="text-center"><object type="image/svg+xml" data="./icon/dryer.svg" class="icon">Hair Dryer</object><br>Hair Dryer (Free on Request)</p> </div><div class="col col-4"> <p class="text-center"><object type="image/svg+xml" data="./icon/beach-towel.svg" class="icon">Beach Towels</object><br>Beach Towels</p> </div><div class="col col-4"> <p class="text-center"><object type="image/svg+xml" data="./icon/iron.svg" class="icon">Iron and Ironing Board</object><br>Iron and Ironing Board upon request</p> </div> </div> <ol class="room-features mb-5"><li>Ocean Inspired Refreshing Bathroom Amenities </li><li>Daily Breakfast at Maaga</li><li >Free SUP, Canoe, Windsurf & Paddleboat included in your room rate</li> </ol>                                             -->
                    <div class="room-text" v-html="item.TileDetails"></div>
                    <div class="text-center" v-if="page == 'specialoffers'">
                      <a
                        class="btn palatin-btn"
                        style="background-color: #5da9ae; color: white; font-weight: bold;"
                        :href="item.TileLink"
                        target="_blank"
                        >Book Now</a
                      >
                      <!-- remove comment if requirement changes -->
                      <!-- <a
                        class="btn palatin-btn"
                        style="background-color: #5da9ae; color: white; font-weight: bold;"
                        href="https://reservations.travelclick.com/108582?themeid=19315#/guestsandrooms"
                        target="_blank"
                        v-if="item.TileImageTitle === 'Private Offers' || item.TileImageTitle === 'Eid Offer'"
                        >Book Now</a
                      >
                      <a
                        class="btn palatin-btn"
                        style="background-color: #5da9ae; color: white; font-weight: bold;"
                        v-else
                        data-toggle="modal"
                        data-target="#bookingDialog"
                        @click="
                          (selectedPackage = item.TileImageTitle),
                            setLimits(item)
                        "
                        >Book This Package</a
                      > -->
                    </div>
                    <div class="text-center" v-if="page == 'rooms'">
                      <a
                        href="https://reservations.travelclick.com/108582?themeid=19315#/guestsandrooms"
                        target="_blank"
                        class="btn palatin-btn"
                        style="background-color: #5da9ae; color: white; font-weight: bold;"
                        >Book This Room</a
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Modal -->
        <div
          class="modal fade"
          id="exampleModal"
          tabindex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content" style="background-color: transparent;">
              <div class="modal-header" style="border-bottom: none;">
                <button
                  type="button"
                  class="close white-text"
                  data-dismiss="modal"
                  aria-label="Close"
                  style="font-size: 2.5rem;"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body" style="padding: 0;">
                <div
                  id="carouselExampleControls"
                  class="carousel slide"
                  data-ride="carousel"
                >
                  <div class="carousel-inner">
                    <div
                      class="carousel-item w-100 active"
                      :style="
                        'background-image: url(\'https://www.malahini.mv:9443/web/api/picture/' +
                          firstPic +
                          '\'); height: 80vh; background-position: center; background-size: contain; background-repeat:no-repeat;'
                      "
                    ></div>
                    <div
                      class="carousel-item w-100"
                      v-for="(pic, index) in modalSlides"
                      :key="index"
                      v-if="index != 0"
                      :style="
                        'background-image: url(\'https://www.malahini.mv:9443/web/api/picture/' +
                          pic +
                          '\'); height: 80vh; background-position: center; background-size: contain; background-repeat:no-repeat;'
                      "
                    ></div>
                  </div>
                  <a
                    class="carousel-control-prev"
                    href="#carouselExampleControls"
                    role="button"
                    data-slide="prev"
                  >
                    <span
                      class="carousel-control-prev-icon"
                      aria-hidden="true"
                    ></span>
                    <span class="sr-only">Previous</span>
                  </a>
                  <a
                    class="carousel-control-next"
                    href="#carouselExampleControls"
                    role="button"
                    data-slide="next"
                  >
                    <span
                      class="carousel-control-next-icon"
                      aria-hidden="true"
                    ></span>
                    <span class="sr-only">Next</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- PDF Modal -->
        <div
          class="modal fade"
          id="pdfModal"
          tabindex="-1"
          role="dialog"
          aria-labelledby="pdfModalLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-lg" role="document" style="width: 90%;margin: auto;">
            <div class="modal-content" style="background-color: transparent;">
              <div class="modal-header" style="border-bottom: none;">
                <button
                  type="button"
                  class="close white-text"
                  data-dismiss="modal"
                  aria-label="Close"
                  style="font-size: 2.5rem;"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body" style="padding: 0; background: white; overflow: scroll;">
                <!-- <object :data="pdfFile" type="application/pdf"  style="width: 100%; height: 80vh;">
                                alt : <a :href="pdfFile">File</a>
                            </object> -->
                <!-- <embed :src="`${pdfFile}#zoom=100`" width="575" height="500"> -->
                <!-- {{ pdfFile }} -->
                <div v-if="docLoading">
                  Loading ...
                </div>
                <div v-if="modalFrom === 'detailFiles'">
                  <div v-if="isPdf">
                    <pdf
                    v-for="i in numPages"
                    :key="i"
                    :src="src"
                    :page="i"
                    ></pdf>
                  </div>
                  <object
                    v-else
                    :data="`./files/${pdfFile}`"
                    style="width: auto; height: 80vh;"
                    border="0"
                ></object>
                </div>
                
                <object
                  v-else
                  :data="`${pdfFile}`"
                  style="width: auto; height: 80vh;"
                  border="0"
                ></object>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- ##### Rooms Area End ##### -->
    <!-- Booking Modal -->
    <div
      id="bookingDialog"
      class="modal fade h-100"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
      style="background-color: #ffffffdb"
    >
      <div class="modal-dialog modal-lg h-100" role="document">
        <div class="modal-content" style="height: 90%; overflow-y: auto;">
          <div class="modal-body p-5">
            <div class="row">
              <div class="col-md-12">
                <h5 class="">
                  <img
                    :src="require('@/assets/img/core-img/logo.png')"
                    alt=""
                  />
                </h5>
                <div>
                  <h3 class="text-center font-weight-bolder mb-5">
                    Book {{ selectedPackage }}
                  </h3>
                  <div class="row  justify-content-md-center">
                    <div class="col-md-4 p-3">
                      <div class="form-group">
                        <p
                          for="name"
                          class="control-label mb-1"
                          style="color: #212529;"
                        >
                          First Name *
                        </p>
                        <input
                          type="text"
                          class="form-control book modal-book"
                          v-model="bookFirstName"
                        />
                      </div>
                    </div>
                    <div class="col-md-4 p-3">
                      <div class="form-group">
                        <p
                          for="name"
                          class="control-label mb-1"
                          style="color: #212529;"
                        >
                          Last Name *
                        </p>
                        <input
                          type="text"
                          class="form-control book modal-book"
                          v-model="bookLastName"
                        />
                      </div>
                    </div>
                    <div class="col-md-4 p-3">
                      <div class="form-group">
                        <p
                          for="name"
                          class="control-label mb-1"
                          style="color: #212529;"
                        >
                          Email *
                        </p>
                        <input
                          type="text"
                          class="form-control book modal-book"
                          v-model="bookEmail"
                          @input="emailValid = true"
                        />
                      </div>
                      <small class="text-danger" v-if="!emailValid"
                        >Please enter a valid email</small
                      >
                    </div>
                  </div>
                  <div class="row  justify-content-md-center">
                    <div class="col-md-4 p-3">
                      <!-- <div class="form-group">
                                                    <p for="name" class="control-label mb-1" style="color: #212529;">Telephone *</p>
                                                    <input type="number" class="form-control book modal-book"  id="usr" v-model="bookTelephone">
                                                </div> -->
                      <p
                        for="name"
                        class="control-label mb-1"
                        style="color: #212529;"
                      >
                        No of Adults *
                      </p>
                      <select
                        v-model="bookAdults"
                        class="form-control book modal-book"
                      >
                        <!-- <option value="0">Adult</option> -->
                        <option value="1 Adult">1 Adult</option>
                        <option value="2 Adults" selected>2 Adults</option>
                        <option value="3 Adults">3 Adults</option>
                        <option value="4 Adults">4 Adults</option>
                        <option value="5 Adults">5 Adults</option>
                        <option value="6 Adults">6 Adults</option>
                        <option value="7 Adults">7 Adults</option>
                        <option value="8 Adults">8 Adults</option>
                        <option value="9 Adults">9 Adults</option>
                        <option value="10 Adults">10 Adults</option>
                      </select>
                    </div>
                    <div class="col-md-4 p-3">
                      <div class="form-group">
                        <!-- <p for="name" class="control-label mb-1" style="color: #212529;">No of Guests *</p>
                                                    <select class="form-control book modal-book" id="rooms" v-model="bookAdults">
                                                        <option value="1">1</option>
                                                        <option value="2">2</option>
                                                        <option value="3">3</option>
                                                        <option value="4">4</option>
                                                        <option value="5">5</option>
                                                        <option value="6">6</option>
                                                        <option value="7">7</option>
                                                        <option value="8">8</option>
                                                        <option value="9">9</option>
                                                        <option value="10">10</option>
                                                        <option value="11">11</option>
                                                        <option value="12">12</option>
                                                        <option value="13">13</option>
                                                        <option value="14">14</option>
                                                        <option value="15">15</option>
                                                    </select> -->
                        <p
                          for="name"
                          class="control-label mb-1"
                          style="color: #212529;"
                        >
                          No of Childrens *
                        </p>
                        <select
                          v-model="bookChildrens"
                          class="form-control book modal-book"
                        >
                          <option value="0 Children" selected
                            >0 Children</option
                          >
                          <option value="1 Children">1 Children</option>
                          <option value="2 Childrens">2 Childrens</option>
                          <option value="3 Childrens">3 Childrens</option>
                          <option value="4 Childrens">4 Childrens</option>
                          <option value="5 Childrens">5 Childrens</option>
                          <option value="6 Childrens">6 Childrens</option>
                          <option value="7 Childrens">7 Childrens</option>
                          <option value="8 Childrens">8 Childrens</option>
                          <option value="9 Childrens">9 Childrens</option>
                          <option value="10 Childrens">10 Childrens</option>
                        </select>
                      </div>
                    </div>
                    <div class="col-md-4 p-3">
                      <div class="form-group">
                        <p
                          for="name"
                          class="control-label mb-1"
                          style="color: #212529;"
                        >
                          Dates *
                        </p>
                        <functional-calendar
                          v-model="calanderData"
                          :configs="calendarConfigs"
                        ></functional-calendar>
                        <!-- {{calanderData}} -->
                      </div>
                    </div>
                    <div class="col-md-12 p-3">
                      <div class="form-group">
                        <p
                          for="name"
                          class="control-label mb-1"
                          style="color: #212529;"
                        >
                          Comment
                        </p>
                        <input
                          type="text"
                          class="form-control book modal-book"
                          v-model="bookComment"
                        />
                      </div>
                    </div>
                  </div>
                  <!-- <div class="row  justify-content-md-center">    
                                                                                    
                                            <div class="col-md-4 p-3">
                                                <div class="form-group">
                                                    <p for="name" class="control-label mb-1" style="color: #212529;">Telephone *</p>
                                                    <input type="text" class="form-control book modal-book"  id="usr">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row  justify-content-md-center">                                            
                                            <div class="col-md-4 p-3">
                                                <div class="form-group">
                                                    <p for="name" class="control-label mb-1" style="color: #212529;">Dates</p>
                                                    <functional-calendar  :is-modal='true' :is-date-range='true'></functional-calendar>
                                                </div>
                                            </div>
                                            <div class="col-md-4 p-3">

                                                <div class="form-group">
                                                    <p for="name" class="control-label mb-1" style="color: #212529;">Rooms</p>
                                                    <select class="form-control book modal-book" id="rooms">
                                                        <option value="1" selected>1 Room</option>
                                                        <option value="1">2 Rooms</option>
                                                        <option value="1">3 Rooms</option>
                                                        <option value="1">4 Rooms</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div> -->

                  <div class="col-12 p-3">
                    <div class="form-check">
                      <label class="form-check-label">
                        <input
                          type="checkbox"
                          class="form-check-input"
                          value=""
                          v-model="bookAgree"
                        />*I consent to my personal data being stored and
                        processed for the purposes of processing my inquiry. For
                        more information view our
                        <a
                          class="link"
                          href="https://www.malahini.mv/cookie_policy.html"
                          >Privacy Policy.</a
                        >
                      </label>
                    </div>
                    <!-- {{checkDisabled()}} -->
                    <button
                      id="modalBooking"
                      type="submit"
                      class="btn palatin-btn mt-50"
                      :disabled="checkDisabled()"
                      @click="bookPackage()"
                    >
                      Book
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End of booking modal -->
    <!-- VR area -->
    <section class="virtual-area mb-5" v-if="showVirtual">
      <div class="embed-responsive virtual-area embed-responsive-21by9">
        <iframe
          class="embed-responsive-item"
          :src="
            `https://geckodigital.co/vt/MalahiniKudaBandos/?ss=${showVirtual}`
          "
          width="100%"
          height="600px"
          frameborder="0"
        ></iframe>
      </div>
    </section>
    <div
      style="position: sticky; bottom: 12%; right: 0; z-index: 20"
      class="d-flex justify-content-end"
    >
      <div class="toast " data-autohide="true" aria-atomic="true">
        <div class="toast-body bg-success text-white">
          <strong class="mr-auto"
            >Thank you for submission. Our reservation team will get back to you
            with your confirmation shortly.</strong
          >
        </div>
      </div>
    </div>

    <!-- https://geckodigital.co/vt/MalahiniKudaBandos/?ss=scene_Aerial_BlooBeach
https://geckodigital.co/vt/MalahiniKudaBandos/?ss=scene_Aerial_Watersports
https://geckodigital.co/vt/MalahiniKudaBandos/?ss=scene_BeachVilla_Bedroom
https://geckodigital.co/vt/MalahiniKudaBandos/?ss=scene_GardenRoom
https://geckodigital.co/vt/MalahiniKudaBandos/?ss=scene_BluuCafe
https://geckodigital.co/vt/MalahiniKudaBandos/?ss=scene_Spa_Gardens
https://geckodigital.co/vt/MalahiniKudaBandos/?ss=scene_Spa_TreatmentRoom -->
  </div>
</template>
<script>
import { _ } from "vue-underscore";
import $ from "jquery";
import "bootstrap";
import VueAwesomeSwiper from "vue-awesome-swiper";
import { FunctionalCalendar } from "vue-functional-calendar";
import moment from "moment";
import pdf from 'vue-pdf'
// require styles
import "swiper/dist/css/swiper.css";

// $('[data-toggle="tooltip"]').tooltip();
// $('#carouselExampleIndicators').carousel({
//   interval: 3000,
//   cycle: true
// });
export default {
  name: "pagedetails",
  data: () => ({
    offerList: {},
    loadingPage: true,
    selectedTile: {},
    showVirtual: null,
    swiperOptionA: {
      pagination: {
        el: ".swiper-pagination",
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      autoplay: {
        delay: 2000,
      },
      observer: true,
      observeParents: true,
    },
    swiperOptionB: {
      pagination: {
        el: ".swiper-pagination",
        dynamicBullets: true,
      },
      autoplay: {
        delay: 2000,
      },
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },

      observer: true,
      observeParents: true,
    },
    modalSlides: null,
    firstPic: "",
    pdfFile: "",
    page: "",
    modalFrom: "",
    selectedPackage: "",
    travelDates: [{ min: "20/02/2020", max: "01/02/2020" }],
    calendarConfigs: {
      isModal: true,
      isDateRange: true,
      sundayStart: true,
      isMultiple: true,
      dateFormat: "dd/mm/yyyy",
      limits: { min: "10/02/2020", max: "20/02/2020" },
      placeholder: " ",
    },
    calanderData: {},
    bookFirstName: "",
    bookLastName: "",
    bookEmail: "",
    bookTelephone: "",
    bookAdults: "2 Adults",
    bookChildrens: "0 Children",
    bookComment: "",
    bookAgree: false,
    emailValid: true,
    metaKeywords: "",
    metaDescription: "",
    numPages: null,
    src: '',
    docLoading: false,
    isPdf: false
  }),
  metaInfo() {
    return {
      title:
        "Malahini Kuda Bandos - " + this.$route.params.mainType + " details",
      meta: [
        { charset: "utf-8" },
        // { name: "description", content: "Malahini Kuda Bandos" + this.$route.params.mainType + ' details'},
        { name: "description", content: this.metaDescription },
        {
          name: "keywords",
          content: "Malahini,Kuda Bandos," + this.metaKeywords,
        },
      ],
    };
  },
  components: {
    LocalSwiper: VueAwesomeSwiper.swiper,
    LocalSlide: VueAwesomeSwiper.swiperSlide,
    "functional-calendar": FunctionalCalendar,
    pdf
  },
  computed: {
    swiperA() {
      return this.$refs.awesomeSwiperA.swiper;
    },
    swiperB() {
      return this.$refs.awesomeSwiperB.swiper;
    },
  },
  mounted() {
    this.page = this.$route.params.mainType;
    // console.log(this.$route.params.roomType.replace(/\s/g,''))
    document.getElementById("roomArea").scrollIntoView();
    this.getData();

    // Dynamically load the external script
    const script1 = document.createElement("script");
    script1.src = "https://static.123compareme.com/CmprmInit-min.js";
    script1.type = "text/javascript";
    document.head.appendChild(script1);

    // Listen for the script load event
    script1.onload = () => {
      // Initialize the CmprmInit after the script has loaded
      document.addEventListener('CmprmInitLoaded', function(event) {
        CmprmInit.InitK8(278);
      }, false);
    };
  },
  beforeDestroy() {
    // Cleanup the event listener when the component is destroyed
    document.removeEventListener('CmprmInitLoaded', this.cmprmInitListener);
  },
  watch: {
    //    call the method if the route changes
    //    '$route': (to, from) => {
    //        this.getData()
    //         let notSpace = to.params['roomType'].replace(/\s/g,'')
    //         // console.log(notSpace)
    //         $(`#roomTabs a[href="#${notSpace}"]`).tab('show')
    //         // console.error(notSpace)
    //         // window.location.reload()
    //    }
    "$route.params": {
      handler(newValue) {
        const { userName } = newValue;
        // console.log(this.$route.params)
        this.getData();

        $(".nav-link.active").removeClass("active");
        $(this)
          .parent(".nav-link")
          .addClass("active");
      },
      immediate: true,
    },
  },
  methods: {
    getData() {
      this.page = this.$route.params.mainType;
      this.$http
        .get("https://www.malahini.mv:9443/web/api/page/" + this.page)
        .then((response) => {
          this.offerList = response.data;
          this.offerList.tiles = _.sortBy(this.offerList.tiles, "TileOrder");
          for (let tile of this.offerList.tiles) {
            if (tile.TileSlidesCSV) {
              let foo = tile.TileSlidesCSV.replace(/\s/g, "");
              let foo2 = foo.split(",");
              tile.TileSlidesCSV = foo2.filter(function(el) {
                return el != "";
              });
              // console.log(tile.TileSlidesCSV)
            }
          }
          setTimeout(() => {
            let notSpace = this.$route.params["roomType"].replace(/\s/g, "");
            $(`#roomTabs a[href="#${notSpace}"]`).tab("show");
            // $('.custom1').owlCarousel({
            //     animateOut: 'slideOutDown',
            //     animateIn: 'flipInX',
            //     items:1,
            //     margin:30,
            //     stagePadding:30,
            //     smartSpeed:450
            // });
            if (this.$route.params.roomType.substring(0, 4) == "tile") {
              this.metaKeywords = this.offerList.tiles[
                this.$route.params.roomType[4]
              ].Keywords;
              this.metaDescription = this.offerList.tiles[
                this.$route.params.roomType[4]
              ].Description;
              // console.log(this.metaKeywords.Keywords)
            }
            this.selectedTile = this.offerList.tiles[
              parseInt(
                this.$route.params["roomType"].substring(
                  this.$route.params["roomType"].length - 1
                )
              )
            ];
            switch (this.selectedTile.TileImageTitle) {
              case "Beach Villa":
                this.showVirtual = "scene_BeachVilla_Bedroom";
                break;
              case "Garden Room":
                this.showVirtual = "scene_GardenRoom";
                break;
              case "Bluu":
                this.showVirtual = "scene_Aerial_BlooBeach";
                break;
              case "Bar 75":
                this.showVirtual = "scene_Aerial_Watersports";
                break;
              case "Spa":
                this.showVirtual = "scene_Spa_Gardens";
                break;
              case "Spa":
                this.showVirtual = "scene_Spa_TreatmentRoom";
                break;
              case "Waterports":
                this.showVirtual = "scene_Aerial_Watersports";
                break;
              default:
                this.showVirtual = null;
            }
          }, 500);
          this.loadingPage = false;
        });
    },
    changeRoute(type) {
      // console.log('/')
      $(`#roomTabs a[href="#${type.replace(/\s/g, "")}"]`).tab("show");
      $(".nav-link.active").removeClass("active");
      $(this)
        .parent(".nav-link")
        .addClass("active");
      this.$router.push({
        name: "pages",
        params: { mainType: this.$route.params.mainType, roomType: type },
      });
    },
    onSetTranslate() {
      // console.log('onSetTranslate')
    },
    openModal(tile) {
      this.firstPic = tile.TileSlidesCSV[0];
      this.modalSlides = tile.TileSlidesCSV;
      // console.log(this.modalSlides)
      // $("#exampleModal").modal()
    },
    openPdfModal(link, type) {
      // console.log(link)
      this.pdfFile = link
      this.isPdf = false
      if (this.pdfFile.includes('.pdf')) {
        this.isPdf = true
        this.docLoading = true
        this.src = pdf.createLoadingTask('./files/' + this.pdfFile)
        this.src.promise.then(pdf => {
              this.numPages = pdf.numPages;
              this.docLoading = false
        })
      }
      this.modalFrom = type;
      // console.log(link)
      $("#pdfModal").modal();
    },
    setLimits(item) {
      // item.TravelStart = "2020-02-01T00:00:00Z"
      // item.TravelEnd = "2020-02-21T00:00:00Z"
      // console.log(moment(item.TravelStart).format('DD/MM/YYYY'), moment(item.TravelEnd).format('DD/MM/YYYY'),)
      this.calendarConfigs.limits.min = moment(item.TravelStart).format(
        "DD/MM/YYYY"
      );
      this.calendarConfigs.limits.max = moment(item.TravelEnd).format(
        "DD/MM/YYYY"
      );
    },
    checkDisabled() {
      return (
        this.bookFirstName == "" ||
        this.bookLastName == "" ||
        this.bookEmail == "" ||
        !this.bookAgree ||
        this.calanderData == {}
      );
    },
    bookPackage() {
      var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (re.test(this.bookEmail)) {
        this.emailValid = true;
        let emailObj = {
          fromName: this.bookFirstName + " " + this.bookLastName,
          fromEmail: this.bookEmail,
          emailSubject: "Request for book " + this.selectedPackage,
          message:
            "Request for book " +
            this.selectedPackage +
            ". Travel Start Date: " +
            this.calanderData.dateRange.start.date +
            " & Travel End Date:" +
            this.calanderData.dateRange.end.date +
            ". No of Adults: " +
            this.bookAdults +
            " & No of Childrens: " +
            this.bookChildrens +
            ". Comment: " +
            this.bookComment,
        };
        this.$http
          .post(
            "https://www.malahini.mv:9443/web/api/email/send",
            JSON.stringify(emailObj),
            {
              headers: {
                Accept: "application/json, text/plain, */*",
                "Content-Type": "text/plain; charset=utf-8",
              },
            }
          )
          .then((response) => {
            // console.log(emailObj)
            $("#bookingDialog").modal("hide");
            $(".toast").toast({ delay: 2000 });
            $(".toast").toast("show");
            (this.bookFirstName = ""),
              (this.bookLastName = ""),
              (this.bookEmail = ""),
              (this.bookAgree = false);
          });
      } else {
        this.emailValid = false;
        this.bookEmail = "";
      }
    },
  },
};
</script>

<style>
.carousel-inner img {
  width: 100%;
  height: 100%;
}
.carousel-indicators li {
  width: 15px;
  height: 15px;
  margin-right: 10px;
  border-radius: 100%;
}
.carousel-indicators {
  text-align: right;
  float: right;
  right: 1% !important;
  left: inherit;
  margin-right: 0%;
  margin-bottom: 20px;
}
.swiper-container {
  height: 100vh;
  width: 100%;
}
.swiper-pagination-bullet {
  width: 15px;
  height: 15px;
}

.swiper-pagination-bullet-active {
  background-color: #5ea8ae;
}
.swiper-container-horizontal
  > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic {
  left: 90%;
}
.page-list > li > a,
p > a,
.list-inline-item > a {
  color: #5ea8ae !important;
}
.icon {
  width: 30px;
  height: 30px;
}
.vfc-styles-conditional-class .vfc-multiple-input input {
  color: black;
}
/* svg>g>path {
    fill: white;
    width: 20px;
}
svg {
    width: 20px;
} */
</style>
